import { render, staticRenderFns } from "./viewCandidateCompany.vue?vue&type=template&id=631c48b2"
import script from "./viewCandidateCompany.vue?vue&type=script&lang=js"
export * from "./viewCandidateCompany.vue?vue&type=script&lang=js"
import style0 from "./viewCandidateCompany.vue?vue&type=style&index=0&id=631c48b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports